import { Injectable } from "@angular/core";
import { Data } from "../modules/facetec/dto";
import { safeStringify } from "ajv/dist/compile/codegen/code";

@Injectable({
    providedIn: "root",
})
export class DataService {
    private readonly STORAGE_KEY = "facetec_data";

    private readonly FRONT_DATA_KEY = "facetec_frontData";

    private readonly AXON_FLAGS_KEY = "facetec_axonFlags";

    setFrontData(data: Data): void {
        sessionStorage.setItem(this.FRONT_DATA_KEY, safeStringify(data));
    }

    getFrontData(): Data | null {
        const storedData = sessionStorage.getItem(this.FRONT_DATA_KEY);
        return storedData ? JSON.parse(storedData) : null;
    }

    setData(data: Data): void {
        console.log("data", { ...data, imageList: [] });
        sessionStorage.setItem(this.STORAGE_KEY, safeStringify(data));
    }

    getData(): Data | null {
        const storedData = sessionStorage.getItem(this.STORAGE_KEY);
        return storedData ? JSON.parse(storedData) : null;
    }

    // Optional: Method to clear stored data
    clearData(): void {
        sessionStorage.removeItem(this.STORAGE_KEY);
    }

    setAxonFlags(flags: any): void {
        console.log("Setting Axon Flags", { flags });
        sessionStorage.setItem(this.AXON_FLAGS_KEY, safeStringify(flags));
    }

    getAxonFlags(): any {
        const storedFlags = sessionStorage.getItem(this.AXON_FLAGS_KEY);
        return storedFlags ? JSON.parse(storedFlags) : null;
    }
}
